export default __webpack_public_path__ + "static/media/interior-metal-fabrication-1000x1000.53553962.webp";